// client/src/utils/leagueStatusUtils.js

/**
 * League status utility functions
 *
 * Centralizes status-related logic for league management.
 * Provides functions for formatting, transitions, and phase checking.
 */

import {
  LEAGUE_STATUS,
  PRIMARY_NEXT_STATUS_BY_LEAGUE_STATUS,
  formatStatus as formatLeagueStatus,
} from '../constants/leagueStatuses'

/**
 * Format a league status for display
 * @param {string} status - League status to format
 * @returns {string} Formatted status string
 */
export function formatStatus(status) {
  return formatLeagueStatus(status)
}

/**
 * Get the next status in the league workflow
 * @param {string} currentStatus - Current league status
 * @returns {string|undefined} Next status or undefined if no transition exists
 */
export function getNextStatus(currentStatus) {
  return PRIMARY_NEXT_STATUS_BY_LEAGUE_STATUS[currentStatus]
}

/**
 * Get user-friendly text for the next status transition
 * @param {string} currentStatus - Current league status
 * @returns {string|undefined} Action text for next status or undefined if no transition exists
 */
export function getNextStatusText(currentStatus) {
  const messages = {
    [LEAGUE_STATUS.DRAFT]: 'Open Registration',
    [LEAGUE_STATUS.REGISTRATION_OPEN]: 'Close Registration',
    [LEAGUE_STATUS.REGISTRATION_CLOSED]: 'Publish Divisions',
    [LEAGUE_STATUS.PENDING_START]: 'Start League',
    [LEAGUE_STATUS.ACTIVE]: 'Start Playoffs',
    [LEAGUE_STATUS.IN_PROGRESS]: 'Start Playoffs',
    [LEAGUE_STATUS.PLAYOFFS_SETUP]: 'Publish Bracket',
    [LEAGUE_STATUS.PLAYOFFS]: 'Complete League',
  }
  return messages[currentStatus]
}

/**
 * Check if a league is in any playoff phase
 * @param {string} status - League status to check
 * @returns {boolean} True if league is in playoffs or playoffs setup
 */
export function isPlayoffPhase(status) {
  return (
    status === LEAGUE_STATUS.PLAYOFFS || status === LEAGUE_STATUS.PLAYOFFS_SETUP
  )
}
